'use strict'

import React, { useEffect, useState } from 'react'
import { Range } from 'react-range';
import './PriceFilter.css'

function PriceFilter (props) {
  //console.info(props)
  const [from, setFrom] = useState(Number(props.range.from))
  const [to, setTo] = useState(Number(props.range.to))
  const [inputValues, setInputValues] = useState([String(props.range.from), String(props.range.to)])
  const [opened, setOpened] = useState(true)

  useEffect(() => {
   setFrom(Number(props.range.from))
   setTo(Number(props.range.to))
   setInputValues([String(props.range.from), String(props.range.to)])
  }, [props.range])

  function onChangeRange(values) {
    setFrom(Number(values[0]))
    setTo(Number(values[1]))
    setInputValues([String(values[0]), String(values[1])])
  }

  function applyInputValue(index) {
    const value = Number(inputValues[index])
    const isValid = inputValues[index] !== '' && !Number.isNaN(value) &&
      (index === 0 ? value < to : value > from)

    if (!isValid) {
      setInputValues([String(from), String(to)])
      return
    }

    const values = index === 0 ? [value, to] : [from, value]
    setFrom(values[0])
    setTo(values[1])
    setInputValues(values.map(String))
    props.onChange(values)
  }

  return (
    <>
      {
        !Number.isNaN(from) && !Number.isNaN(to) && from < to ?
          <div className={`filter-box ${opened ? 'active' : ''} price-box`}>
            <div className="filter-box__title" onClick={() => (setOpened(!opened))}>{props.title}</div>
            <div className={`filter-box__container ${!opened ? 'collapsed' : ''}`}>
              <div className="parameters-block">
                <Range
                  step={10}
                  min={props.range.min}
                  max={props.range.max}
                  values={[from, to]}
                  onChange={onChangeRange}
                  onFinalChange={values => {props.onChange([from, to])}}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: '3px',
                        width: '100%',
                        backgroundColor: '#d8d8d8'
                      }}
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => {
                    return <span className={`price-thumb-${props.key + 1}`}
                                 {...props}
                                 style={{
                                   ...props.style,
                                   height: '24px',
                                   width: '19px',
                                   backgroundColor: 'none'
                                 }}
                    />
                  }}
                />
                <div className="filter-parameters">
                  <div className="filter-parameters-box bx-left">
                    <div className="bx-filter-input-container">
                      <input className="min-price" type="text" name="price-min"
                             id="price-min" value={inputValues[0]} size="5" placeholder="Від"
                             onChange={event => setInputValues([event.target.value, inputValues[1]])}
                             onBlur={() => applyInputValue(0)}/>
                    </div>
                  </div>
                  <div className="filter-parameters-box bx-right">
                    <div className="bx-filter-input-container">
                      <input className="max-price" type="text" name="price_max"
                             id="price_max" value={inputValues[1]} size="5" placeholder="До"
                             onChange={event => setInputValues([inputValues[0], event.target.value])}
                             onBlur={() => applyInputValue(1)}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> :
          <></>
      }
    </>
  )
}

export default PriceFilter